import styled from "styled-components";

const AppLayout = styled.main`
  display: grid;
  grid-template-columns: minmax(200px, 4fr) 8fr;
`;

export default AppLayout;
